import PropTypes from 'prop-types';

export const constantType =
  PropTypes.shape({
    fromId: PropTypes.func.isRequired,
    fromName: PropTypes.func.isRequired,
  });

export const findingType = PropTypes.shape({
  id: PropTypes.string,
  orgId: PropTypes.string,
  name: PropTypes.string,
  category: PropTypes.number,
  created: PropTypes.string,
  createdBy: PropTypes.string,
  analysis: PropTypes.string,
  priority: PropTypes.number,
  jurisdiction: PropTypes.number,
  type: PropTypes.number,
  tags: PropTypes.arrayOf(PropTypes.any),
});

export const constantsType = PropTypes.shape({
  resolution: constantType,
  category: constantType,
  status: constantType,
  type: constantType,
});



// WEBPACK FOOTER //
// ./src/views/Components/Finding/types.js